import { HttpClient } from '@angular/common/http'
import { inject, Injectable } from '@angular/core'

import { environment } from '../../environments/environment'

/** Wem die XID gehört: Einzel-Etikett am Artikel oder Gruppen-Etikett an der Vorlage */
export type XidOwnerType = 'article' | 'article_template'

export interface XidRekeyParams {
  owner_type: XidOwnerType
  owner_id: number
  new_xid: string
  reason: string | null
}

/**
 * RFID-Etiketten (bentomax/hawk#605). Umschlüsseln = neue XID vergeben; die alte
 * landet serverseitig in der Sperrliste und wird nie wieder vergeben.
 */
@Injectable({
  providedIn: 'root'
})
export class XidService {
  private http = inject(HttpClient)

  public rekey(params: XidRekeyParams) {
    const path = environment.apiURL + 'xids/rekey.json'
    return this.http.post<unknown>(path, params)
  }
}
